<div class="row card-header">
  <h3>Edit Lead Details</h3>
</div>

<div class="marginTop row">
  <div class="col-12" *ngIf="erroralert">
      <div class="alert-box grid-100 col-sm-10" *ngIf="errorMessage">
          <div class="alert alert-danger mt-3 text-center">
              <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
              {{errorMessage}}
          </div>
      </div>
  </div>
  <div class="col-12" *ngIf="successalert">
      <div class="alert-box grid-100" *ngIf="successMessage">
          <div class="alert alert-success mt-3 text-center">
              <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
              {{successMessage}}
          </div>
      </div>
  </div>
</div>
<div class="row bg_dashboard justify-content-center">

    <div class="col-md-8">
        <div class="card">
            <div class="card-content">
                <form (ngSubmit)="onSubmit(editLeadForm.value); editLeadForm.reset()" #editLeadForm="ngForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group label-floating">
                                <label class="control-label"> Name</label>
                                <input type="text" class="form-control" name="name" required [(ngModel)]="name">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group label-floating">
                                <label class="control-label">Email</label>
                                <input type="email" class="form-control" name="email" required [(ngModel)]="email">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- <div class="col-md-6">
                            <div class="form-group label-floating">
                                <label class="control-label">City</label>
                                <input type="text" class="form-control" name="city" required [(ngModel)]="city">
                            </div>
                        </div> -->
                        <div class="col-md-6">
                            <div class="form-group label-floating">
                                <label class="control-label">Pin Code</label>
                                <input type="text" class="form-control" name="pincode" [(ngModel)]="pincode">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group label-floating">
                                <label class="control-label">Contact</label>
                                <input type="text" class="form-control" name="contact" required [(ngModel)]="contact">
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <!-- <div class="col-md-6">
                            <div class="form-group label-floating">
                                <label class="control-label">Details</label>
                                <input type="text" class="form-control" name="details" [(ngModel)]="details">
                            </div>
                        </div> -->

                    </div>
                    <button type="submit" class="button pull-right" [disabled]="!editLeadForm.valid">Update</button>
                </form>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/lead/updatelead/updatelead.component.html